import { makeRemoteAccountEnrollments } from '@/main/factories/usecases/account/remote-account-enrollment-factory'
import { RemoteAccountEnrollments } from '@/data/usecases/account/remote-account-enrollments'
import { ApiInstanceResponse } from '@/infra/http/http-service-client/http-service-client-types'
import { queryClient } from '@/infra/http'

/**
 * Loads user enrollments list
 * Simple loader that fetches all enrollments for the current user
 */
export async function loadUserEnrollments(): Promise<RemoteAccountEnrollments.Model> {
  const remoteAccountEnrollments = makeRemoteAccountEnrollments(queryClient)
  const result =
    (await remoteAccountEnrollments.loader()) as unknown as ApiInstanceResponse<RemoteAccountEnrollments.Model>
  // The API returns { success, message, data }, but we need just the data
  return result.data || (result as unknown as RemoteAccountEnrollments.Model)
}
